import { useEffect, useState } from 'react';
import { EventAPI } from '../../../api/EventAPI';
import { MdOutlinePriceChange } from 'react-icons/md';
import Loader from '../../../component/Loader';
import { isCoach, isUser } from '../../../util/UserRoles';
import styles from '../../../styles/modules/ChildProfile.module.css';
import AddPlanDialog from './AddPlanDialog';
import { useSelector } from 'react-redux';

const PlayerParticipantFee = ({ eventId, playerId, isPlayer, isPlanReplaceable }) => {
    const [participantFee, setParticipantFee] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [openFeePopup, setOpenFeePopup] = useState(false);
    const userInfo = useSelector((store) => store.user.userInfo);
    const getEventPlayerParticipantFee = async () => {
        try {
            setIsLoading(true)
            const response = await EventAPI.getEventPlayerParticipantFee(eventId, playerId);
            setParticipantFee(response.Data)
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        getEventPlayerParticipantFee();
    }, []);


    return (
        <div className={styles['child_guardian_container']}>
            {isLoading && <Loader />}
            {(isUser(userInfo) || isCoach(userInfo)) &&
                <div className={styles['add_memeber_btn']}>
                    <button onClick={() => setOpenFeePopup(true)} typeof='buttom'> <MdOutlinePriceChange className={styles['add_memeber_btn_icon']} />Buy Plan</button>
                </div>}
            <table className={styles['child_guardian_table']}>
                <thead>
                    <tr>
                        <th align='left'>Title</th>
                        <th align='left'>Description</th>
                        <th align='left'>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {participantFee?.map((fee) =>
                        <tr>
                            <td align='left'>{fee.criteria}</td>
                            <td align='left'>{fee.description}</td>
                            <td align='left'>${fee.feeAmount}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <AddPlanDialog
                eventId={eventId}
                playerId={playerId}
                openFeePopup={openFeePopup}
                setOpenFeePopup={setOpenFeePopup}
                isPlayer={isPlayer}
                setIsLoading={setIsLoading}
                existingFeeList={participantFee}
                isPlanReplaceable={isPlanReplaceable}
            />
        </div>
    )
}

export default PlayerParticipantFee